import React, { useEffect, useState } from 'react'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle';
import DashboardContent from '../../dashboardWrapper/DashboardContent';
import Wrapper from '../../dashboardWrapper/Wrapper';
import './style.scss'
import SendMessage from './SendMessage';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetSentMessage, fetchGetSentMessagePagination } from '../../../redux/action/managerMessages/getSentMessages';
import MainLoading from '../../../utils/MainLoading';
import { Button, Modal, OverlayTrigger, Pagination, Popover, Table } from 'react-bootstrap';
import moment from "moment-jalaali";
import { fetchGetSingleSentMessage } from '../../../redux/action/managerMessages/getSingleSentMessage';
import { fetchDeleteSingleManagerMessage } from '../../../redux/action/managerMessages/deleteManagerMessage';
import { useTranslation } from 'react-i18next';

const ManagerMessages = () => {
  const [show, setShow] = useState(false)
  const [messageId, setMessageId] = useState('')
  const dispatch = useDispatch()
  const messages = useSelector(state => state.sent_messages)
  const single_sent_message = useSelector(state => state.single_sent_message)
  const deleteManagerMessage = useSelector(state => state.deleteManagerMessage)
  const {t} = useTranslation();
  const lang = localStorage.getItem('lang')

  useEffect(() => {
    if(!messages.sent_messages.data) {
      dispatch(fetchGetSentMessage())
    }
  }, [])

  const update = () => {
    setTimeout(function(){
      dispatch(fetchGetSentMessage())
    }, 1000)
  }

  const showMessage = (id) => {
    setShow(true)
    setMessageId(id)
    dispatch(fetchGetSingleSentMessage(id))
  }

  const handleClose = () => {
    setShow(false)
  }

  const handleDelete = () => {
    dispatch(fetchDeleteSingleManagerMessage(messageId))
    setTimeout(function() {
      dispatch(fetchGetSentMessage())
    }, 1500)
    setShow(false)
  }


  const handlePaginate = (e) => {
    e.preventDefault()
    dispatch(fetchGetSentMessagePagination(e.target.href))
  }

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">{t('delete')} </Popover.Header>
      <Popover.Body>
        <p>{t('delete this item')}</p>
        <div className='d-flex justify-content-end'>
          <button className='btn btn-sm btn-danger' onClick={handleDelete}>{t('delete')}</button>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <Wrapper>
      <DashboardContent>
        <DashboardMainTitle> {t("dashboard_nav_manager_messages")} </DashboardMainTitle>
        {messages.loading?
          <MainLoading />
        :
          messages.sent_messages.data &&
            messages.sent_messages.data.length ?
              <>
              <Table bordered responsive>
                <thead>
                    <tr>
                        <th>{t("title")}</th>
                        <th>{t("message")}</th>
                        <th>{t("date")}</th>
                        <th className='text-center'>{t("management")}</th>
                    </tr>
                </thead>
                <tbody>
                  {messages.sent_messages.data.map(message => (
                      <tr key={message.id}>
                        <td> {message.title}</td>
                        <td style={{ maxWidth: '260px'}}>
                        <p style={{maxHeight: '68px', overflow: 'hidden', padding: '0 .1rem'}}>{message.description}</p>
                        </td>
                        <td >
                          {lang === 'en' ?
                            message.send_time.substr(11, 5)+' - '+message.send_time && message.send_time.substr(0, 10)
                          :
                            message.send_time.substr(11, 5)+' - '+moment(message.send_time && message.send_time.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                          }
                        </td>
                        <td className='text-center'><button className='btn btn-success btn-sm px-3' onClick={id => showMessage(message.id)}>{t("management")}</button></td>
                      </tr>
                    ))}
                </tbody>
              </Table> 
              <div className='pagination_container mt-3'>
                <Pagination>
                    {messages.sent_messages.links ? messages.sent_messages.links.map(link => (
                        <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                            {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                        </Pagination.Item>
                    )) : ''}
                </Pagination>
              </div>
              </>
            :
              <h6 className='text-center'>{t("There is no message")}</h6>
        }
        <SendMessage update={update} />
      </DashboardContent>
      
      {show && 
        <Modal show={show} onHide={handleClose}>
          {single_sent_message.loading ?
            <MainLoading />
          :
            single_sent_message.single_sent_message ?
              <>
                <Modal.Header closeButton>
                <Modal.Title>{single_sent_message.single_sent_message.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                      {single_sent_message.single_sent_message.description}
                    </div>
                    <div className='mt-4 pt-2' style={{borderTop: '1px solid rgb(240, 240, 240)'}}>
                      <p> {t("sent t")} :</p>
                      <div>
                        {single_sent_message.single_sent_message.message_users.length ?
                          single_sent_message.single_sent_message.message_users.map(user => (
                            <div className='my-2' key={user.id}>
                              <span style={{fontWeight: user.state === "sended" ? 'bold' : '100' }}> {user.to}{user.state === "sended" && ' (دیده نشده) ' } ، </span>
                              <br />
                            </div>
                          ))
                        :
                            '-'
                        }
                      </div>
                    </div>
                    <div className='d-flex justify-content-end mt-4 pt-2'>
                        <p className='text-muted text-left'>
                          {lang === 'en' ?
                            single_sent_message.single_sent_message.send_time.substr(11, 5)+' - '+single_sent_message.single_sent_message.send_time && single_sent_message.single_sent_message.send_time.substr(0, 10)
                          :
                            single_sent_message.single_sent_message.send_time.substr(11, 5)+' - '+moment(single_sent_message.single_sent_message.send_time && single_sent_message.single_sent_message.send_time.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                          }
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                  <Button variant="success">{t("delete")}</Button>
                </OverlayTrigger>
                <Button variant="secondary" onClick={handleClose}>
                    {t("close")}
                </Button>
                </Modal.Footer>
              </>
            :
              <>
                <Modal.Body>
                      <p  className='text-muted text-left'>{t("toast_something_went_wrong")}</p>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  {t("close")}
                </Button>
                </Modal.Footer>
              </>
          }
          
        </Modal>}
    </Wrapper>
  )
};

export default ManagerMessages;
